import { PropsWithChildren, createContext, useContext } from 'react'

const RouteViewParamContext = createContext<string | null | undefined>(null)

export function useRouteViewParam<T extends string>() {
  return useContext(RouteViewParamContext) as T
}

export function RouteViewParamProvider<T extends string>(
  props: PropsWithChildren<{ viewParam: T | null | undefined }>
) {
  return <RouteViewParamContext.Provider value={props.viewParam} children={props.children} />
}
